import React from 'react';
import { SERVER_URL } from '../constants'

const useWallet = () => {
  const route = 'wallets';

  const [wallets, setWallets] = React.useState({deposits: [], withdraws: []});
  const [loading, setLoading] = React.useState(true);

  const user = JSON.parse(localStorage.getItem('user'));
  if (!user) window.location.href = '/login';

  const getWallets = async () => {
    setLoading(true);
    const response1 = await fetch(`${SERVER_URL}/deposits/`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      }
    });
    const data1 = await response1.json();
    const response2 = await fetch(`${SERVER_URL}/withdraws/`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      }
    });
    const data2 = await response2.json();
    setWallets({
      deposits: data1,
      withdraws: data2,
    });
    setLoading(false);
  };

  const createWallet = async (wallet) => {
    setLoading(true);
    const response = await fetch(`${SERVER_URL}/${route}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
      body: JSON.stringify(wallet),
    });
    const data = await response.json();
    setWallets([...wallets, data]);
    setLoading(false);
  };

  const updateWallet = async (wallet) => {
    setLoading(true);
    const response = await fetch(`${SERVER_URL}/${route}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
      body: JSON.stringify(wallet),
    });
    const data = await response.json();
    const index = wallets.findIndex((w) => w.id === wallet.id);
    setWallets([...wallets.slice(0, index), data, ...wallets.slice(index + 1)]);
    setLoading(false);
  };

  const deleteWallet = async (id) => {
    setLoading(true);
    const response = await fetch(`${SERVER_URL}/${route}/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      }
    });
    const data = await response.json();
    setWallets(wallets.filter((w) => w.id !== id));
    setLoading(false);
  };

  React.useEffect(() => {
    getWallets();
  }, []);

  return {
    loading,
    wallets,
    setWallets,
    getWallets,
    createWallet,
    updateWallet,
    deleteWallet,
  };
};

export default useWallet;
